import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../_services/message.service';

import { Agent } from '../_models/agent';
import { Globals } from '../_globals/globals';

import { DbTransform } from '../_helpers/db.transform';


@Injectable({
  providedIn: 'root'
})

export class AgentService {

  dbt: DbTransform;

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {
    this.dbt = new DbTransform(localStorage.getItem('enviroment')); //this.globals.currentUserEnviroment);
  }

  getAgents(searchParams): Observable<Agent[]> {

    console.log('-->--> Ejecutando servicio getAgents.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Agent[]>(this.globals.apiUrl + '/agents', options)
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getAgents: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Agent[]>('getAgents', [])
      ));
  }

  getAllAgents(): Observable<Agent[]> {

    console.log('-->--> Ejecutando servicio getAllAgents');

    return this.http.get<Agent[]>(this.globals.apiUrl + '/agents')
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getAllAgents: ' + JSON.stringify(data))),
        catchError(this.handleError<Agent[]>('getAllAgents', [])
      ));
  }

  getAgent(searchParams): Observable<Agent> {

    console.log('-->--> Ejecutando servicio getAgent');
    console.log(searchParams);
    console.log('---------------');

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: new HttpParams()
        .set('id', searchParams.id)
    };
    return this.http.get<Agent>(this.globals.apiUrl + '/agent', options)
      .pipe(
        tap(  _ => this.log('get agent')),
        catchError(this.handleError<Agent>('getAgent', null)
      ));
  }

  updateAgent(agentIn: Agent): Observable<Agent> {

    console.log('-->--> Ejecutando servicio updateAgent');
    console.log(agentIn);
    console.log('---------------');

    let options = {};
    if (agentIn.user_id === null) {
      options = { params: new HttpParams()
        .set('user_id', '0') };
    } else {
      options = { params: new HttpParams()
        .set('user_id', agentIn[this.dbt.t('user_id')].toString()) };
    }

    return this.http.put<Agent>(this.globals.apiUrl + '/agent', agentIn, options)
      .pipe(
        tap(  _ => this.log('updated agent')),
        catchError(this.handleError<Agent>('updateAgent', null)
      ));
  }

  createAgent(agentIn: Agent): Observable<Agent> {

    console.log('-->--> Ejecutando servicio createAgent');
    console.log(agentIn);
    console.log('---------------');

    let options = {};

    return this.http.post<Agent>(this.globals.apiUrl + '/agent', agentIn, options)
      .pipe(
        tap(  _ => this.log('created agent')),
        catchError(this.handleError<Agent>('createAgent', null)
      ));

  } // End function createAgent

  deleteAgent(agentIn: Agent): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteAgent');
    console.log(agentIn);
    console.log('---------------');

    let options = { params: new HttpParams()
        .set('id', agentIn[this.dbt.t('id')].toString())
        .set('user_id', agentIn[this.dbt.t('user_id')].toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/agent', options)
      .pipe(
        tap(  _ => this.log('deleted agent')),
        catchError(this.handleError<bigint>('deleteAgent', null)
      ));
  } // End function deleteAgent

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }

  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
